import { Dialog } from '@factorialco/f0-react/dist/experimental'
import { PagesDiscardPageDraftDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

interface DiscardPageDraftDialogProps {
  pageId: number
  lastVersionContent: string
  onClose: () => void
}

export const DiscardPageDraftDialog = ({
  pageId,
  lastVersionContent,
  onClose,
}: DiscardPageDraftDialogProps) => {
  const [discardPageDraft] = useMutation(PagesDiscardPageDraftDocument, {
    extractorFn: (data) => data.handbookPagesMutations.updateHandbookpagesPage,
  })

  const handleConfirmDelete = async () => {
    const result = await discardPageDraft({
      variables: {
        id: pageId,
        content: lastVersionContent,
      },
    })

    const handler = handleResult(result, () => null)

    if (handler.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('pages.page.discard_page_draft_dialog.success'),
      })
    } else {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('common.error'),
      })
    }

    onClose()
  }

  return (
    <Dialog
      onClose={onClose}
      actions={{
        primary: {
          label: i18n.t('pages.page.discard_page_draft_dialog.button_discard'),
          onClick: () => handleConfirmDelete(),
          variant: 'default',
        },
        secondary: {
          label: i18n.t('common.cancel'),
          onClick: onClose,
        },
      }}
      header={{
        description: i18n.t('pages.page.discard_page_draft_dialog.description'),
        title: i18n.t('pages.page.discard_page_draft_dialog.title'),
        type: 'info',
      }}
      open={!!pageId}
    />
  )
}
